import { render, staticRenderFns } from "./installer-maintain-order.vue?vue&type=template&id=8bb21a90&scoped=true&"
import script from "./installer-maintain-order.vue?vue&type=script&lang=js&"
export * from "./installer-maintain-order.vue?vue&type=script&lang=js&"
import style0 from "./installer-maintain-order.vue?vue&type=style&index=0&id=8bb21a90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb21a90",
  null
  
)

export default component.exports